import { CARD_NAMES, get_points_for_card, VANGUARDS } from '../../TwoD/Common/CardUtilities';

export default function artificialDraftAction(gamePlayerController, aiPackage) {
    const gamePlayer = gamePlayerController.gamePlayerData;
    let cardScores = [];

    if (!gamePlayerController.gameData.draft_choices.length > 0) {
        console.error('missing draft choices');
        return;
    }


    gamePlayerController.gameData.draft_choices.map((cardId, draftIndex) => {
        let cardScore = 0;
        [0, 1, 2, 3].forEach((_, dockIndex) => {
            let cardData = get_points_for_card(
                gamePlayer.station, gamePlayer.robot_assignments,
                gamePlayer.lodging, cardId, dockIndex,
                true, VANGUARDS.includes(cardId));
            if (cardData.points !== 'Danger') {
                cardScore += cardData.points;
            }
        })
        cardScores.push(cardScore);
    });
    let choiceIndex = (cardScores[0] > cardScores[1]) ? 0 : 1;
    let choice = gamePlayerController.gameData.draft_choices[choiceIndex];
    const cardName = CARD_NAMES[choice];
    aiPackage.success = true;
    aiPackage.addToMessage(`Draft ${cardName}`);
    aiPackage.addProvenance(
        `Is the first Card's score across all docks is greater?`,
        cardName,
        `${cardScores[0]} > ${cardScores[1]}`);
    if (aiPackage.execute) {
        gamePlayerController.gamePlayerApi.clickDraftChoice(choice);
    }
}
